import { ProductType } from '../types/product-type.enum';

/** Product types supported by the public setup flow (excludes business cards). */
export const SETUP_SUPPORTED_PRODUCT_TYPES = new Set<ProductType>([
  ProductType.GOOGLE,
  ProductType.INSTAGRAM,
  ProductType.MENU,
  ProductType.TIKTOK,
  ProductType.FACEBOOK,
  ProductType.CUSTOM,
]);

/** Product types shown on the select-type step, in display order. */
export const SETUP_SELECTABLE_PRODUCT_TYPES: ProductType[] = [
  ProductType.GOOGLE,
  ProductType.INSTAGRAM,
  ProductType.TIKTOK,
  ProductType.FACEBOOK,
  ProductType.MENU,
  ProductType.CUSTOM,
];

const URL_SETUP_PRODUCT_TYPES = new Set<ProductType>([
  ProductType.CUSTOM,
  ProductType.MENU,
  ProductType.FACEBOOK,
]);

export function isSupportedSetupProductType(
  type: string | null | undefined,
): type is ProductType {
  return type != null && SETUP_SUPPORTED_PRODUCT_TYPES.has(type as ProductType);
}

/** Types that collect a target URL on the custom-url step (not search/suggestions). */
export function usesUrlSetupFlow(type: ProductType | undefined): boolean {
  return type != null && URL_SETUP_PRODUCT_TYPES.has(type);
}
